import * as requestFromServer from "./settingsCrud";
import {settingsSlice, callTypes} from "./settingsSlice";

const {actions} = settingsSlice;

export const fetchSettings = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findSettings()
    .then(response => {
      const entities = response.data.data;
      dispatch(actions.settingsFetched({ entities }));
    })
    .catch(error => {
      error.clientMessage = "Can't find settings";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSetting = id => dispatch => {
  if (!id) {
    return dispatch(actions.settingFetched({ settingForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getSettingById(id)
    .then(response => {
      const {data} = response.data;
      dispatch(actions.settingFetched({ settingForEdit: data }));
    })
    .catch(error => {
      error.clientMessage = "Can't find setting";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchOneSetting = id => dispatch => {
  if (!id) {
    return dispatch(actions.settingFetched({ settingForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getOneSetting(id)
    .then(response => {
      const {data} = response.data;
      dispatch(actions.settingFetched({ settingForEdit: data }));
    })
    .catch(error => {
      error.clientMessage = "Can't find setting";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteSetting = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteSetting(id)
    .then(response => {
      dispatch(actions.settingDeleted({ id }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete setting";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateSetting = setting => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateSetting(setting)
    .then(() => {
      dispatch(actions.settingUpdated({ setting }));
    })
    .catch(error => {
      error.clientMessage = "Can't update setting";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateSettingsStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForSettings(ids, status)
    .then(() => {
      dispatch(actions.settingsStatusUpdated({ ids, status }));
    })
    .catch(error => {
      error.clientMessage = "Can't update settings status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteSettings = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteSettings(ids)
    .then(() => {
      dispatch(actions.settingsDeleted({ ids }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete settings";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
